import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import { searchUrl } from '@/constants/urls';
import {
  columnCode,
  columnDescription,
  columnNameLink,
  columnMultiSelect,
  columnVisibility,
  columnTools,
  hasColumn,
} from '@/constants/fields';
import VisibilityCell from '@/components/table/VisibilityCell';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';
import SearchTools from '../containers/SearchTools';

const SearchRow = ({
  category,
  search,
  onCheckBoxClick,
  upward,
  className,
  columns = [columnMultiSelect, columnNameLink, columnCode, columnDescription, columnVisibility, columnTools],
}) => (
  <NameDescriptionRow
    className={clsx('aridhia-search-row', className)}
    code={search.code}
    columns={columns}
    description={search.description}
    entity="search"
    href={searchUrl(search)}
    name={search.name}
    onSelect={() => onCheckBoxClick(category, search.code)}
    selected={search.selected}
  >
    {hasColumn(columns, columnVisibility) && (<VisibilityCell visibility={search.visibility} />)}
    {hasColumn(columns, columnTools) && (
      <Table.Cell collapsing>
        <SearchTools
          url={searchUrl(search, '#')}
          upward={upward}
          category={category}
          search={search}
        />
      </Table.Cell>
    )}
  </NameDescriptionRow>
);

export default SearchRow;
